import { durationFormat } from './timeformat.js'
export const mixin = {
  data () {
    return {
      audioFlag: false,
      audioCurrent: 0,
      audioDuration: 0,
      audioCurrentFormat: '00:00',
      audioDurationFormat: '00:00',
      audioSeek: false
    }
  },
  mounted() { 
    this.audio = new Audio()
    // this.audio.src = 'http://manageweb.oss-cn-beijing.aliyuncs.com/speaker/%E5%9D%A4%E5%B8%85_demo.mp3'
    // console.dir(this.audio)
    this.audioMark = new Audio()
    this.audioMark.src = 'http://myna-bgm.oss-cn-beijing.aliyuncs.com/svoice_watermark.mp3'
    this.audioMark.loop = true
    this.initAudio()
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from, next)
    this.audio.pause()
    this.audio.currentTime = 0
    next()
  },
  methods: {
    initAudio () {
      this.audio.onplay = () => {
        console.log('配音制作: AUDIO onplay')
        const reg = /.*\.mp3/
        if(reg.test(this.audio.src)) {
          this.playAudio()
        }
      }
      // 音频：暂停
      this.audio.onpause = () => {
        console.log('配音制作: AUDIO onPause')
        this.pauseAudio()
      }
      // 音频：播放结束
      this.audio.onended = () => {
        console.log('配音制作: AUDIO onEnd')
        this.audioCurrent = 0
        this.audioCurrentFormat = '00:00'
        this.pauseAudio()
      }
      this.audio.oncanplay = () => {
        console.log('配音制作: AUDIO onCanplay')
        // eslint-disable-next-line no-unused-expressions
        this.audio.duration // 先调用一次，相当于初始化一次
        console.log(this.audio.duration)
      }
      this.audio.ontimeupdate = () => {
        // console.log(e.currentTime)
        // console.log('onTimeUpdate', this.audio.currentTime)
        if (!this.audioSeek) {
          const curTime = this.audio.currentTime
          this.audioCurrent = curTime
          this.audioCurrentFormat = durationFormat(curTime)
        }
        if (!this.audioDuration && this.audio.duration) {
          this.audioDuration = Math.ceil(this.audio.duration)
          this.audioDurationFormat = durationFormat(Math.ceil(this.audio.duration))
          console.log(Math.ceil(this.audio.duration), durationFormat(Math.ceil(this.audio.duration)))
        }
      }
      this.audio.onseeked = () => {
        this.audioSeek = false
      }
      this.audio.onerror = (res) => {
        console.log(res)
        this.audioURL = ''
        this.audio.pause()
        this.pauseAudio()
        if (this.audio.src === window.location.href) {
          return
        }
        this.$toast('音频出错')
      }
    },
    pauseAudio () {
      this.audioFlag = false
      this.audioMarkFlag && this.audioMark.pause()
    },
    playAudio () {
      this.audioFlag = true
      this.audioMark.currentTime = 0
      if (this.audioMarkFlag) {
        this.audioMark.play()
      } else {
        this.audioMark.pause()
      }
    },
  }
}